import React, { useState } from 'react';

/**
 * Images are proxied through our backend to guarantee they load.
 * No more CORS, CSP, or Wikimedia issues.
 */
function DirectImage({ imgKey }) {
  const [failed, setFailed] = useState(false);
  // Use our backend proxy — guaranteed to work
  const url = `/api/quiz/image-proxy/${imgKey}`;

  if (failed) return null;

  return (
    <div style={{ maxWidth: 280, margin: '0 auto' }}>
      <img
        src={url}
        alt=""
        onError={() => setFailed(true)}
        style={{
          width: '100%', maxHeight: 220, objectFit: 'contain', borderRadius: 12,
          border: '2px solid rgba(255,255,255,0.1)', boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
          background: 'rgba(0,0,0,0.2)',
        }}
      />
    </div>
  );
}

function FlagImage({ code }) {
  // Double source pour fiabilité : 0 = notre backend (clé flag_<code>),
  // 1 = flagcdn en repli, 2 = on abandonne. Un échec d'un côté bascule sur
  // l'autre au lieu d'afficher du vide (un seul onError masquait tout avant).
  const [stage, setStage] = useState(0);
  if (stage >= 2) return null;
  const src = stage === 0
    ? `/api/quiz/image-proxy/flag_${code}`
    : `https://flagcdn.com/w320/${code}.png`;
  return (
    <div style={{ maxWidth: 200, margin: '0 auto' }}>
      <img
        key={stage}
        src={src}
        alt={`Drapeau ${code}`}
        onError={() => setStage(s => s + 1)}
        style={{
          width: '100%', maxHeight: 120, objectFit: 'contain', borderRadius: 10,
          border: '2px solid rgba(255,255,255,0.1)', boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
        }}
      />
    </div>
  );
}

export default function QuestionImage({ imageUrl }) {
  if (!imageUrl) return null;
  if (imageUrl.startsWith('flag:')) return <div className="question-image-container"><FlagImage code={imageUrl.split(':')[1]} /></div>;
  if (imageUrl.startsWith('img:') || imageUrl.startsWith('body:')) {
    return <div className="question-image-container"><DirectImage imgKey={imageUrl.split(':')[1]} /></div>;
  }
  return null;
}
